import { CarWashIcon } from './CarWashIcon';

/**
 * author: Google
 * id 95E617D7-9A48-458E-96C5-A8CBBEF3A852
 * name car-wash
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-wash.svg
 * tags
 * - Transportation + Road 
 * - Places 
 * - Automotive 
 */
export const LocalCarWashIcon = CarWashIcon;
export default LocalCarWashIcon